module.exports = __webpack_public_path__ + "static/media/newsletters-archive.2b30a252.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsletters-archive.svg
// module id = 367
// module chunks = 0